import { type Validator, regex } from "react-admin";

type RegexFn = (pattern: RegExp, message?: string) => Validator;

const typedRegex: RegexFn = regex as RegexFn;

export const regexValidator = (
  pattern: RegExp,
  message = "Invalid format",
): Validator => typedRegex(pattern, message);
